export enum ZPrinterMinVersions {
  ZPrinterClosureMinVersion = '4.12.0',
}
